// js/sections/media-grid.liquid
import {timeline, inView} from "//echowater.com/cdn/shop/t/185/assets/vendor.min.js?v=110043496098797809611748333813";

var MediaGrid = class extends HTMLElement {
    connectedCallback() {

        this.items = Array.from(this.children);
        if (window.matchMedia("(prefers-reduced-motion: no-preference)").matches) {
            inView(this, this.onBecameVisible.bind(this));
        }
        this.isParalaxMode = this.classList.contains('paralax');
        if (this.isParalaxMode) {
            this.prepareMediaItems();
            this.setInitialOffsetValues();
            this.calculateStepValues();
            window.addEventListener('resize', () => this.calculateMoveProps());
            this.setMediaItemsOffsets();
            window.addEventListener('scroll', () => this.handleScroll());
        }
    }

    prepareMediaItems() {
        this.oddMediaItems = this.querySelectorAll('.media-grid__item:nth-child(odd)');
        this.evenMediaItems = this.querySelectorAll('.media-grid__item:nth-child(even)');
    }

    setInitialOffsetValues() {
        this.enableOffset = false;
        this.startOffsetFirst = 50;
        this.startOffsetSecond = -50;
        this.endOffsetFirst = -10;
        this.endOffsetSecond = 10;
        this.height = this.offsetHeight;
        this.updateOffsetFirst(this.startOffsetFirst);
        this.updateOffsetSecond(this.startOffsetSecond);
    }

    calculateStepValues() {
        this.stepFirst = (this.startOffsetFirst + Math.abs(this.endOffsetFirst)) / this.height;
        this.stepSecond = (Math.abs(this.startOffsetSecond) + Math.abs(this.endOffsetSecond)) / this.height;
    }

    calculateMoveProps() {
        this.height = this.offsetHeight;
        this.calculateStepValues();
    }

    setMediaItemsOffsets() {
        this.updateMediaItemsTransform(this.oddMediaItems, this.offsetFirst - 100);
        this.updateMediaItemsTransform(this.evenMediaItems, this.offsetSecond + 100);
    }

    updateMediaItemsTransform(mediaItems, value) {
        mediaItems.forEach(item => {
            item.style.transform = `translateY(${value}px)`;
        });
    }

    onBecameVisible() {
        const contentElements = this.querySelectorAll(".content-over-media > :not(img, video, iframe, svg, video-media, native-video, external-video)");
        timeline([
            [this.items, {opacity: 1}, {duration: 0.3}],
            [contentElements, {opacity: [0, 1]}, {duration: 0.2, at: "+0.1"}]
        ]);
    }

    handleScroll() {
        let bottomOffset = this.getElementBottomOffset(this);
        if (bottomOffset >= 0 && bottomOffset <= this.height) {
            this.enableItemsOffset = true;
            this.updateOffsetFirst(this.startOffsetFirst - this.stepFirst * bottomOffset);
            this.updateOffsetSecond(this.startOffsetSecond + this.stepSecond * bottomOffset);
        } else if (bottomOffset < 0) {
            this.updateOffsetFirst(this.startOffsetFirst);
            this.updateOffsetSecond(this.startOffsetSecond);
        } else if (bottomOffset > this.height) {
            this.updateOffsetFirst(this.endOffsetFirst);
            this.updateOffsetSecond(this.endOffsetSecond);
        }
        if (this.enableOffset) {
            this.enableOffset = false;
        }
        this.setMediaItemsOffsets();
    }

    getElementBottomOffset(element) {
        let bounding = element.getBoundingClientRect();
        return window.innerHeight - bounding.top;
    }

    updateOffsetFirst(value) {
        this.offsetFirst = value;
    }

    updateOffsetSecond(value) {
        this.offsetSecond = value;
    }
};
if (!window.customElements.get("media-grid")) {
    window.customElements.define("media-grid", MediaGrid);
}